import { useState, useEffect, useRef } from 'react';
import { scrollToSectionUtils } from '../../../core/utils/scroll_to_section_ultils.jsx';

export const useHeaderViewModel = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isHeaderVisible, setIsHeaderVisible] = useState(true);
    const lastY = useRef(0);

    useEffect(() => {
        if (isMenuOpen) {
            document.documentElement.classList.add('menu-open');
            document.body.classList.add('menu-open');
        } else {
            document.documentElement.classList.remove('menu-open');
            document.body.classList.remove('menu-open');
        }
        return () => {
            document.documentElement.classList.remove('menu-open');
            document.body.classList.remove('menu-open');
        };
    }, [isMenuOpen]);

    useEffect(() => {
        const onScroll = () => {
            const y = window.scrollY;
            const showHeader = y <= 50 || y <= lastY.current;
            setIsHeaderVisible(showHeader);
            lastY.current = y;
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleScrollToSection = (sectionId) => {
        scrollToSectionUtils(sectionId, () => setIsMenuOpen(false));
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const handleLogoClick = () => {
        window.location.reload();
    };

    return {
        isMenuOpen,
        isHeaderVisible,
        handleScrollToSection,
        toggleMenu,
        closeMenu,
        handleLogoClick,
    };
};
